module.exports = __webpack_public_path__ + "static/media/fast_working.2c671f91.svg";